import MUIAccordionSummary from '@mui/material/AccordionSummary'

export const AccordionSummary = MUIAccordionSummary
